require("@rails/ujs").start()
require("channels")
// Stimulusで代用
import "@nathanvda/cocoon"

const images = require.context('../images', true)
const imagePath = (name) => images(name, true)

import '../stylesheets/application.scss'